module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sendTo":"Send to","sendSMS":"Send text message","send":"Send","cancel":"Cancel","messageSent":"Message sent","length":"characters","smsLimitExceeded":"Text message size limit exceeded","noPhoneNumber":"no phone number indicated","sms":"Text Messages"}}')
  delete Component.options._Ctor
}
